
import React, { useEffect } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Forge from './pages/Forge';
import PfpGenerator from './pages/PfpGenerator';
import Board from './pages/Board';
import Dojo from './pages/Dojo';
import { signInUser } from './services/firebase';

const App: React.FC = () => {
  
  // Auto Login on Mount
  useEffect(() => {
    signInUser();
  }, []);

  return (
    <HashRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/forge" element={<Forge />} />
          <Route path="/pfp" element={<PfpGenerator />} />
          <Route path="/board" element={<Board />} />
          <Route path="/dojo" element={<Dojo />} />
        </Routes>
      </Layout>
    </HashRouter>
  );
};

export default App;
